import * as React from "react";
import { cn } from "../../lib/utils";

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  children: React.ReactNode;
}

export function Select({ className, children, ...props }: SelectProps) {
  return (
    <select
      className={cn(
        "w-full px-4 py-2 border border-gray-300 rounded-lg bg-white text-foreground",
        "focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary",
        "hover:border-primary transition-colors",
        "disabled:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      {...props}
    >
      {children}
    </select>
  );
}